var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoHansefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 61,
    viewBox: "0 0 122 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#335466",
    x: 0.5,
    y: 0.5,
    width: 121,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.573 18.707h108.173v21.147H10.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "m49.613 24.4-1.667 9.76h-2.04l.68-3.946h-3.198l-.68 3.946h-2.041l1.7-9.76h2.042l-.68 3.911h3.197l.68-3.911z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.094 32.574h-3.451l-.74 1.586h-2.29l4.79-9.76h2.783l1.374 9.76h-2.29l-.176-1.586zm-.211-1.832-.247-2.466c-.07-.67-.14-1.727-.105-2.185h-.035c-.106.494-.564 1.515-.846 2.185l-1.162 2.466h2.395z",
    fill: "#335466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.742 30.813h.037c.037-.74.258-2.185.369-2.854l.663-3.559h2.136l-1.805 9.76h-2.063l-1.915-4.017c-.368-.74-.736-1.726-.81-2.29h-.037c-.037.74-.258 2.185-.368 2.854l-.626 3.453h-2.136l1.804-9.76h2.063l1.952 4.193c.294.67.663 1.691.736 2.22z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.724 27.074c0-2.313 1.715-3.487 4.048-3.487 2.436 0 3.397 1.285 3.054 3.12h-2.161c.137-.734-.138-1.321-1.201-1.321-1.098 0-1.579.624-1.579 1.321 0 .514.344.771 1.03 1.028l1.647.661c.995.404 1.646 1.101 1.646 2.24 0 2.312-1.852 3.524-4.22 3.524-2.641 0-3.5-1.395-3.156-3.23h2.161c-.137.807.172 1.431 1.304 1.431 1.132 0 1.681-.587 1.681-1.322 0-.55-.411-.77-.892-.954l-1.818-.771c-.926-.404-1.544-1.138-1.544-2.24z",
    fill: "#335466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "m83.99 26.232-.385 2.15h3.891l-.315 1.726H83.29l-.386 2.185h4.347l-.315 1.867H80.52l1.718-9.76h6.415l-.315 1.867H83.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#335466",
    d: "m92.968 26.267-.425 2.326h3.855l-.319 1.867h-3.854l-.637 3.7h-2.121l1.732-9.76H97.6l-.318 1.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M100.652 34.16h-2.239l1.828-9.76h2.239zM111.12 26.267h-2.485l-1.328 7.893h-2.043l1.328-7.893h-2.485l.306-1.867h7.014zM10.573 18.707v21.146H31.72V18.707H10.573zm8.495 15.602H16.9l.71-4.052h-3.376l.355-1.954h3.412l.711-4.016h2.168l-1.812 10.022zm8.53-4.087H24.22l-.71 4.051h-2.169l1.777-10.022h2.168l-.71 4.016h3.411l-.39 1.955z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoHansefit);
export default __webpack_public_path__ + "static/media/kundenlogo-hansefit.3e03ced024125f1ad0154498a201cad9.svg";
export { ForwardRef as ReactComponent };